module.exports = __webpack_public_path__ + "img/alarm.2930b5ce.svg";